import { createTheme } from "@mui/material/styles";
import { type AppState, useSelector } from "common-frontend/src/store/Store";
import * as R from "ramda";
import { useEffect } from "react";
import components from "./Components";
import { DarkThemeColors } from "./DarkThemeColors";
import { baseDarkTheme, baselightTheme } from "./DefaultColors";
import { LightThemeColors } from "./LightThemeColors";
import { darkshadows, shadows } from "./Shadows";
import typography from "./Typography";

const BuildTheme = (config: any = {}) => {
  const themeOptions = LightThemeColors.find(
    (theme) => theme.name === config.theme,
  );
  const darkthemeOptions = DarkThemeColors.find(
    (theme) => theme.name === config.theme,
  );
  const customizer = useSelector((state: AppState) => state.customizer);
  const defaultTheme =
    customizer.activeMode === "dark" ? baseDarkTheme : baselightTheme;
  const defaultShadow =
    customizer.activeMode === "dark" ? darkshadows : shadows;
  const themeSelect =
    customizer.activeMode === "dark" ? darkthemeOptions : themeOptions;
  const baseMode = {
    palette: {
      mode: customizer.activeMode,
    },
    shape: {
      borderRadius: 7,
    },
    shadows: defaultShadow,
    typography: typography,
  };
  const theme = createTheme({
    ...R.mergeDeepRight(
      R.mergeDeepRight(baseMode, defaultTheme),
      themeSelect as any,
    ),
    direction: config.direction,
  });
  theme.components = components(theme);

  return theme;
};

const ThemeSettings = () => {
  const activDir = useSelector((state: AppState) => state.customizer.activeDir);
  const activeTheme = useSelector(
    (state: AppState) => state.customizer.activeTheme,
  );
  const theme = BuildTheme({
    direction: activDir,
    theme: activeTheme,
  });
  useEffect(() => {
    document.dir = activDir;
  }, [activDir]);

  return theme;
};

export { ThemeSettings };
